import { AppBar, withStyles } from '@material-ui/core';
import { Entity, ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { RED } from '../../_config/consts.js';
import { getColorFromThemeName } from '../../_config/utils.js';
import * as AreaActions from '../../redux/actions/area.actions';
import * as GuestActions from '../../redux/actions/guest.actions';
import * as ModalActions from '../../redux/actions/modal.actions';
import EmptyView from '../EmptyView.jsx';
import SimpleExportMenu from '../ExportMenus/SimpleExportMenu.jsx';
import DateRangeView from '../forms/Fields/DatePickers/DateRangePicker/DateRangeView.jsx';
import MDButton from '../MDButton/MDButton.jsx';
import AreasDetailsTable from '../MetricCharts/MetricChartComponents/AreasDetailsTable.jsx';

const styles = theme => ({
  titleText: {
    margin: 0,
    fontWeight: 'bold',
    color: '#3f3f3f',
    marginTop: 5,
  },
  header: {
    marginTop: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%'
  },
  chartsContainer: {
    flexWrap: 'unset !important',
    margin: 25,
    marginTop: 40,
    width: 'auto'
  },
});

const validate = (values) => {
  const errors = {};
  return errors;
};

@reduxForm({ form: 'AreasReportViewFilters', validate })
@connect(state => ({ 
  areas: state.areas,
  routing: state.router,
  viewLoading: state.utils.viewLoading,
  themeName: state.settings.items.theme.data.themeName,
  form: state.form.AreasReportViewFilters,
  areaReport: state.areas.areaReport,
}))
class AreasReportView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      focusedInput: null,
      filteredAreas: [],
      initialArea: null,
    };
  }

  componentDidMount() {
    this.applyFilters();
    const { dispatch, areaReport } = this.props;
    const { areas: { data: { content: areasData } } } = this.props;
    if (areasData && areasData.length > 0) {
      let initialArea = areasData[0]
      this.setState({ initialArea: initialArea });
      dispatch(AreaActions.setAreaReportSelectedArea(initialArea));
      dispatch(AreaActions.setAreaReportFilter('areaIds', [initialArea.id]));
      this.fetchReportData();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { areas, areaReport } = this.props;
    const { fromDate, toDate } = areaReport.filters;
    
    if (prevProps.areas !== areas || 
        prevProps.areaReport.filters.fromDate !== fromDate || 
        prevProps.areaReport.filters.toDate !== toDate) {
      this.applyFilters();
    }
  }

  applyFilters() {
    const { areas } = this.props;
    const areaData = areas?.data?.content || [];
    
    let filtered = areaData;
    
    this.setState({ filteredAreas: filtered });
  }

  fetchReportData() {
    const { dispatch } = this.props;
    dispatch(AreaActions.fetchAndSaveAreaReport());
    const additionalFilters = {
      page: 0,
      pageSize: 1000,
    };
    dispatch(AreaActions.fetchAndSaveAreaReportDetails(additionalFilters));
  }

  onDateRangeSelected(startDate, endDate) {
    const { dispatch } = this.props;
    // Use the dates as passed from the date picker
    const isDateRangeValid = moment(endDate).diff(moment(startDate), 'months') <= 12;
    if (!isDateRangeValid) {
      dispatch(ModalActions.showModal({
        modalType: 'WARNING_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="dateRangeInvalid" /></h6>),
        },
      }));
      return;
    }
    // Update filters in Redux state
    dispatch(AreaActions.setAreaReportFilter('fromDate', moment(startDate).startOf('day').valueOf()));
    dispatch(AreaActions.setAreaReportFilter('toDate', moment(endDate).endOf('day').valueOf()));
    
    // Refresh data with new date range
    dispatch(AreaActions.resetAreaReportData());
    this.fetchReportData();
  }

  isOutsideRange(day) {
    const { areaReport } = this.props;
    const { focusedInput } = this.state;
    const { fromDate } = areaReport.filters;
    if (focusedInput === 'endDate' && fromDate) {
      const startMoment = moment(fromDate);
      const maxEndDate = moment(startMoment).add(12, 'months');
      return moment(day).isAfter(maxEndDate, 'day');
    }
    return false;
  }

  onResetDateFilters() {
    const { dispatch } = this.props;
    dispatch(AreaActions.setAreaReportFilter('fromDate', moment().startOf('month').valueOf()));
    dispatch(AreaActions.setAreaReportFilter('toDate', moment().endOf('month').valueOf()));
  }

 
  onResetFilters() {
    const { dispatch } = this.props;
    dispatch(AreaActions.resetAreaReportData());
    dispatch({ type: 'RESET', form: 'AreasReportViewFilters' });
  }

  onExportElements(format) {
    const { dispatch, areaReport } = this.props;
    const { selectedAreas, filters } = areaReport;
    const { fromDate, toDate, userIds } = filters;
    
    const areaIds = selectedAreas.map(a => a.id);
    
    if (!areaIds || areaIds.length === 0) {
      // Show error if no area is selected
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="pleaseSelectAreaToExport" /></h6>),
        },
      }));
      return;
    }
    
    const exportFilters = {
      startTime: fromDate,
      endTime: toDate,
      userIds: userIds,
      pageSize: 1000,
    };
    
    dispatch(AreaActions.exportAreaReportDetails(areaIds, exportFilters, format));
  }

  onSelectAreas(areas) {
    const { dispatch } = this.props;
    console.log('areas', areas);
    dispatch(AreaActions.setAreaReportSelectedAreas(areas));
    
    if (areas && areas.length > 0) {
      const areaIds = areas.map(a => a.id);
      dispatch(AreaActions.setAreaReportFilter('areaIds', areaIds));
      this.fetchReportData();
    } else {
      dispatch(AreaActions.setAreaReportFilter('areaIds', []));
    }
  }

  onRefreshMetric() {
    const { areaReport } = this.props;
    const { selectedAreas } = areaReport;
    
    if (selectedAreas && selectedAreas.length > 0) {
      this.fetchReportData();
    } else {
      this.applyFilters();
    }
  }

  onFetchAreaReportDetails(areaIds, page = 0) {
    const { dispatch } = this.props;
    const additionalFilters = {
      page,
      pageSize: 1000,
    };
    // Append data if page > 0 (loading more), otherwise replace
    const append = page > 0;
    return dispatch(AreaActions.fetchAndSaveAreaReportDetails(additionalFilters, append));
  }

  async onFetchGuests(searchText) {
    const { dispatch } = this.props;
    try {
      const guests = await dispatch(GuestActions.fetchGuestsForSelector(searchText));
      return guests || [];
    } catch (error) {
      console.error('Error fetching guests:', error);
      return [];
    }
  }

    onSelectGuest(guestIds) {
    const { dispatch } = this.props;
    dispatch(AreaActions.setAreaReportFilter('userIds', guestIds));
    this.fetchReportData();
  }


  render() {
    const { classes, areas, themeName, areaReport } = this.props;
    const { focusedInput, filteredAreas, initialArea } = this.state;
    const { fromDate, toDate } = areaReport.filters;
    const { selectedAreas, reportData, loading, lastUpdate } = areaReport;
    
    // Backward compatible: get first selected area and its data
    const textColor = getColorFromThemeName(themeName);

    return (
      <div style={{ height: '120vh', paddingBottom: 50, overflow: 'scroll' }}>
        <AppBar position="sticky" color="default" style={{ padding: 10,  display: 'flex', flexDirection: 'row', alignItems: 'center', width: '120%', zIndex: 100 }}>
        <div>
            <DateRangeView
              id="areas-date-selector"
              startDateId="areas-date-selector-start"
              endDateId="areas-date-selector-end"
              startDate={fromDate ? moment(fromDate).startOf('day') : moment().startOf('month')}
              endDate={toDate ? moment(toDate).endOf('day') : moment().endOf('month')}
              noBorder={false}
              endDatePlaceholderText="--/--/--"
              startDatePlaceholderText="--/--/--"
              minimumNight={0}
              style={{ marginTop: 50 }}
              isOutsideRange={day => this.isOutsideRange(day)}
              focusedInput={focusedInput}
              onFocusChange={focusInput => this.setState({ focusedInput: focusInput })}
              onChange={({ startDate, endDate }) => this.onDateRangeSelected(startDate, endDate)}
              onResetOptionSelection={() => this.onResetDateFilters()}
              helpersOptions={[
                {
                  title: L20NContext.getSync('today'),
                  startDate: moment().startOf('day').valueOf(),
                  endDate: moment().endOf('day').valueOf(),
                },
                {
                  title: L20NContext.getSync('thisWeek'),
                  startDate: moment().startOf('week').valueOf(),
                  endDate: moment().endOf('week').valueOf(),
                },
                {
                  title: L20NContext.getSync('thisMonth'),
                  startDate: moment().startOf('month').valueOf(),
                  endDate: moment().endOf('month').valueOf(),
                },
                {
                  title: L20NContext.getSync('last3Months'),
                  startDate: moment().subtract(2, 'months').startOf('month').valueOf(),
                  endDate: moment().endOf('month').valueOf(),
                },
                {
                  title: L20NContext.getSync('last6Months'),
                  startDate: moment().subtract(5, 'months').startOf('month').valueOf(),
                  endDate: moment().endOf('month').valueOf(),
                },
                {
                  title: L20NContext.getSync('last12Months'),
                  startDate: moment().subtract(11, 'months').startOf('month').valueOf(),
                  endDate: moment().endOf('month').valueOf(),
                },
              ]}
            />
            </div>
          <MDButton
            onClick={() => this.onResetFilters()}
            backgroundColor={RED}
            containerStyle={{ margin: 0, marginTop: 0, marginLeft: 20 }}
            title={<Entity entity="resetDateFilters" />}
          />
          <SimpleExportMenu
            titleContainerStyle={{ marginLeft: 40, marginTop: 0 }}
            onExportLogs={format => this.onExportElements(format)}
          />
        </AppBar>
        <div style={{ margin: 25, marginTop: 20 }}>
          {filteredAreas && !_.isEmpty(filteredAreas) ? (
            <AreasDetailsTable
              areas={filteredAreas}
              reportData={reportData}
              reportDetails={areaReport.reportDetails}
              initialArea={initialArea}
              lastUpdate={lastUpdate}
              textColor={textColor}
              isRefreshing={loading}
              fullWidth={true}
              onSelectAreas={areas => this.onSelectAreas(areas)}
              onRefreshMetric={() => this.onRefreshMetric()}
              onFetchAreaReportDetails={(areaIds, page) => this.onFetchAreaReportDetails(areaIds, page)}
              onFetchGuests={searchText => this.onFetchGuests(searchText)}
              onSelectGuest={userId => this.onSelectGuest(userId)}
            />
          ) : (
            <EmptyView
              title="noAreas"
              containerStyle={{ paddingTop: 0, marginTop: 50 }}
              subtitle="noAreasDescription"
              newEntityTitle="addArea"
              onNewEntity={null}
              iconName="icon-simple-line-icons-user-following"
            />
          )}
        </div>
      </div>
    );
  }
} 

export default withStyles(styles)(AreasReportView);
